import { c as _c } from "react/compiler-runtime";
import { SwitchHorizontal02Icon, SwitchVertical01Icon } from '@systemeio/icons';
export function SplitTestSeparator() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="bg-bg-primary border-border-200 h-fit w-fit self-center rounded-full border p-2.25"><SwitchVertical01Icon className="text-icon-primary tablet:hidden size-5.5" /><SwitchHorizontal02Icon className="text-icon-primary max-tablet:hidden size-5.5" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export function SplitTestCardsWrapper(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="tablet:flex-row desktop:gap-5 tablet:gap-3 flex flex-col gap-4">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}